module.exports = __webpack_public_path__ + "img/desenvolvimento-cover.760b69f4.jpg";